import * as React from 'react';
import Lottie from 'react-lottie';
import shipingContainer from 'assets/lottie/container-ship.json';

export const Loading: React.FC = () => {
  return (
    <div className="flex items-center justify-center py-32">
      <Lottie
        options={{ loop: true, autoplay: true, animationData: shipingContainer }}
        height={150}
      />
    </div>
  );
};
Loading.displayName = 'SmartPerDiem.DownloadModal.Loading';
